var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"home-header"},[_c('van-button',{staticClass:"search",attrs:{"block":"","size":"small"},on:{"click":_vm.onSearch}},[_c('span',{staticStyle:{"color":"#8e8e8e","margin-right":"6px"}},[_c('svg-icon',{attrs:{"icon-class":"search","width":15,"height":15}})],1),_c('span',[_vm._v("搜索商品名称")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }